import React, { useState } from 'react';
import { Avatar, Form } from 'antd';
import { LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { AppButton, Block, FlexBox } from '@esg/ui';
import { Controller } from 'react-hook-form';
import { t } from 'i18next';
import { FileUpload } from '@esg/business-upload';
import { FormConnector } from '../inputs/FormConnector';
import './AvatarUpload.scss';
import { UploadImage } from '../upload';

interface AvatarUploadProps {
    readonly translateCode?: string;
    readonly name: string;
    readonly disabled?: boolean;
    readonly shape?: 'circle' | 'square';
    readonly icon?: React.ReactNode;
    readonly size?: number;
    readonly iconHover?: React.ReactNode;
    readonly actionUrl?: string;
}

export const AvatarUpload = (props: AvatarUploadProps) => {
    const { name, size = 100, iconHover, actionUrl } = props;
    const [loading, setLoading] = useState(false);

    const onRender = React.useCallback(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (renderProps: any) => {
            const { onChange, value } = renderProps.field;
            const { error } = renderProps.fieldState;
            const handleChange = (v: FileUpload) => {
                onChange(v.uri ?? '');
            };

            return (
                <Form.Item
                    validateStatus={error ? 'error' : undefined}
                    help={error?.message && t(error?.message)}
                >
                    <FlexBox direction='column' alignItems='center' gap={8}>
                        <UploadImage
                            name={name}
                            onChange={handleChange}
                            setLoading={setLoading}
                            disabled={props.disabled}
                            className='avatar-uploader'
                            actionUrl={actionUrl}
                        >
                            <FlexBox className='avatar-wrapper'>
                                <Avatar
                                    className='avatar-custom'
                                    shape={props.shape}
                                    size={size}
                                    style={{ backgroundColor: '#EAECF0', color: '#0B5DCC' }}
                                    src={value}
                                    icon={!loading ? props.icon : undefined}
                                >
                                    <LoadingOutlined />
                                </Avatar>
                                <Block width={size} height={size} className={`camera ${props.disabled ? 'hidden' : ''}`}>
                                    <Block width={size} height={size} className={props.shape == 'circle' ? 'camera-background-circle' : 'camera-background'} />
                                    <AppButton icon={iconHover} className='icon-camera' shape='circle' />
                                </Block>
                            </FlexBox>
                        </UploadImage>
                    </FlexBox>
                </Form.Item>
            );
        },
        [iconHover, loading, name, props.disabled, props.icon, props.shape, size]
    );

    return (
        <FormConnector>
            {(form) => {
                const { control } = form;
                return (
                    <Controller
                        name={name}
                        control={control}
                        render={onRender}
                    />
                );
            }}
        </FormConnector>
    );
};

AvatarUpload.defaultProps = {
    shape: 'circle',
    icon: <UserOutlined />,
};

